import { css } from '@/styled-system/css';

export const tableResponsiveStyles = css.raw({
  maxWidth: '100%',
  overflowX: 'auto',
  scrollBehavior: 'smooth',
});
